const browserDetect = () => {
	const { userAgent } = window.navigator;
	const browser =
		userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1
			? "Opera"
			: userAgent.indexOf("Edg") !== -1
			? "Edge"
			: userAgent.indexOf("Chrome") !== -1
			? "Chrome"
			: userAgent.indexOf("Safari") !== -1
			? "Safari"
			: userAgent.indexOf("Firefox") !== -1
			? "Firefox"
			: userAgent.indexOf("MSIE") !== -1 || !!document.documentMode === true
			? "IE"
			: "unknown";
	return browser;
};

export default browserDetect;
